  
<html>
  <head>
    <title>Plantillas</title>
  </head>
  <body>
    <div class="container">
      <div class="jumbotron mt-3">
        <h1>Crear</h1>
        <p class="lead">Desde aqui podras crear plantillas para formularios.</p>
        <a routerLink="create" class="btn btn-lg btn-primary" role="button">Crear plantilla »</a>
      </div>
      <div class="jumbotron mt-3">
        <h1>Mis plantillas</h1>
        <p class="lead">Desde aqui podras ver tus plantillas.</p>
        <a routerLink="get" class="btn btn-lg btn-primary" role="button">Ver plantillas»</a>
      </div>
    </div>
  </body>
</html>